class APIS {
	apis() {
		return {
			peakDays: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customers/peak-days'
			},
			peakHours: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customers/peak-hours'
			},
			interactionFrequency: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customers/interaction-frequency'
			},
			engaged: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customers/engaged'
			},
		};
	}
}

export default new APIS();